import { Link } from "react-router-dom";

import { newsItems, newsSection } from "./landingContent";
import { LandingSection } from "./LandingPrimitives";

export default function LandingNewsSection() {
  const items = [...newsItems].sort((a, b) => b.dateIso.localeCompare(a.dateIso));
  if (items.length === 0) return null;

  return (
    <LandingSection
      id="noutati"
      eyebrow={newsSection.eyebrow}
      title={newsSection.title}
      description={newsSection.description}
    >
      <div className="landing-news-list">
        {items.map((item) => {
          const ariaLabel = `${item.linkLabel}: ${item.title}`;
          return (
            <article key={item.href} className="landing-news-card">
              <Link
                to={item.href}
                className="landing-news-card__hit"
                aria-label={ariaLabel}
              >
                <div className="landing-news-card__media">
                  <img
                    src={item.coverSrc}
                    alt={item.coverAlt}
                    className="landing-news-card__image"
                    loading="lazy"
                    decoding="async"
                    width={960}
                    height={640}
                  />
                </div>

                <div className="landing-news-card__body">
                  <div className="landing-news-card__top">
                    <span className="landing-news-card__badge">{item.badge}</span>
                    <div className="landing-news-card__meta">
                      <time dateTime={item.dateIso}>
                        Actualizat · {item.dateLabel}
                      </time>
                      <span className="landing-news-card__meta-sep" aria-hidden="true">
                        ·
                      </span>
                      <span>{item.readingMinutes} min citire</span>
                    </div>
                  </div>

                  <h3 className="landing-news-card__title">{item.title}</h3>
                  <p className="landing-news-card__description">{item.description}</p>

                  <span className="landing-news-card__cta" aria-hidden="true">
                    {item.linkLabel}
                    <span className="landing-news-card__cta-arrow">→</span>
                  </span>
                </div>
              </Link>
            </article>
          );
        })}
      </div>
    </LandingSection>
  );
}
